import React, { useState } from 'react';

import i18n from 'i18n-js';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import BorderColorIcon from '@material-ui/icons/BorderColor';

import { SectionData } from 'store/menuDetailsStore/reducer';
import DailyMenuSectionManagementModal from 'components/menu/MenuManagementTable/components/DailyMenuSectionManagementModal';
import { MenuType } from 'constants/enums';

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

export interface EditDailyMenuSectionProps {
    section: SectionData;
    onClose: any;
    menus: string[];
    menuType: MenuType;
}

export default function EditDailyMenuSection(props: EditDailyMenuSectionProps) {
    const [showEditPopup, setShowEditPopup] = useState(false);

    function handleClose() {
        setShowEditPopup(false);
        props.onClose();
    }

    return (
        <>
            <StyledMenuItem
                color="primary"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowEditPopup(true);
                    props.onClose();
                }}
            >
                <BorderColorIcon fontSize="small" color="disabled" style={{ marginRight: 23 }} />
                <ListItemText primary={i18n.t('common.edit')} />
            </StyledMenuItem>
            <DailyMenuSectionManagementModal
                section={props.section}
                onClose={handleClose}
                isOpen={showEditPopup}
                menuType={props.menuType}
            />
        </>
    );
}
